import React, { Component } from 'react'
import SearchBlock from './Container/SearchBlock'
import InformationBlock from './Container/InformationBlock'

export class Main extends Component {
  state = {
    userData: null,
    error: null
  }

  handleSearch = (data) => {
    this.setState({ userData: data, error: null })
  }

  handleError = (msg) => {
    this.setState({ error: msg, fade: false })

    setTimeout(() => {
      this.setState({ fade: true })
    }, 5500)

    setTimeout(() => {
      this.setState({ error: null, fade: false })
    }, 6000)
  }

  render() {
    return (
      <div className='main'>
        <main>
        <SearchBlock onSearch={this.handleSearch} onError={this.handleError} />
        <InformationBlock userData={this.state.userData} />
        {this.state.error && (
          <div className={`error ${this.state.fade ? 'hide' : ''}`}>
            <h3>Error</h3>
            <p>A user matching your search was found. Check their username.</p>
          </div>)}
        </main>
      </div>
    )
  }
}

export default Main